import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import tenantMenuList from '@menuList';
import useGetLocation from './useGetLocation';

// Matches the current route against the Profolio sidebar menu list to resolve the page's
// already-translated title. Menu-list titles are t()-translated per tenant/locale, so this
// returns the correct Arabic title with no new translation needed. Resolves to '' for routes
// absent from the menu list (e.g. Lite-only routes, which withAdminLayout never renders
// MenueItems for) — callers must handle the empty case themselves.
const useCurrentPageTitle = () => {
  const { user } = useSelector((state) => state.app.loginUser);
  const location = useGetLocation();
  const sideBarList = tenantMenuList.menuList(user?.permissions, user?.agency, user?.type !== 'free');

  return useMemo(() => {
    const pathName = location.pathname;
    const matches = (it) =>
      (it?.path && pathName.includes(it.path)) || (it?.basePath && pathName.includes(it.basePath));

    const entry = sideBarList.find((e) => matches(e) || e?.list?.some(matches));
    if (!entry) return '';
    if (matches(entry)) return entry.title;
    return entry.list.find(matches)?.title || '';
  }, [location.pathname, sideBarList]);
};

export default useCurrentPageTitle;
